export default "__VITE_ASSET__CJBxCekd__"